export const MANAGEMENT_ROLES = [
  "superadmin",
  "mgmt_admin",
  "project_manager",
  "service_user",
] as const;

export type ManagementRole = (typeof MANAGEMENT_ROLES)[number];

const MANAGEMENT_ROLE_ALIASES: Record<string, ManagementRole> = {
  company_management: "project_manager",
};

export const isManagementRole = (role: string): role is ManagementRole =>
  MANAGEMENT_ROLES.includes(role as ManagementRole);

export const normalizeManagementRole = (
  role: string
): ManagementRole | null => {
  const alias = MANAGEMENT_ROLE_ALIASES[role];

  if (alias) return alias;

  return isManagementRole(role) ? role : null;
};
